import { styled } from '@mui/material/styles'
import Switch from '@mui/material/Switch'

const sizes = { small: 1, medium: 1.5, large: 2 }
const AntSwitch = styled(Switch)(({ theme, size = 'medium' }) => ({
  width: 28 * sizes[size],
  height: 16 * sizes[size],
  padding: 0,
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15 * sizes[size],
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: `translateX(${12 * sizes[size]}px)`,
    },
  },
  '.MuiSwitch-track': {
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    // border: '2px solid',
    borderColor: theme.palette.primary.gray,
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: `translateX(${12 * sizes[size]}px)`,
      color: '#fff',
      '& + .MuiSwitch-track': {
        // borderColor: `${theme.palette.primary.dark} !important`,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : theme.palette.primary.main,
        opacity: 1,
      },
      '& .MuiSwitch-thumb': {
        // backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : theme.palette.primary.main,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.primary.gray,
    width: 10 * sizes[size],
    height: 10 * sizes[size],
    borderRadius: 6 * sizes[size],
    transform: `translateX(${1.25 * sizes[size]}px) translateY(${1.25 * sizes[size]}px)`,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: (16 / 2) * sizes[size],
    opacity: 1,
    // backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}))

export default AntSwitch
